import React from 'react'
import PropTypes from 'prop-types'
import './styles.css'

class TileList extends React.Component {
  static propTypes = {
    items: PropTypes.arrayOf(PropTypes.element)
  }

  render = () => {
    return (
      <div className="masonry masonry-shop">
        <div className="row masonry__container masonry--animate masonry--active">
          {this.renderTileList(this.props.items)}
        </div>
      </div>
    )
  }

  renderTileList = (tiles) => (
    tiles.map((tile, index) => (
      <div key={index} className="col-md-4 col-sm-6 masonry__item" data-masonry-filter="accessories">
        {tile}
      </div>
    ))
  )
}

export default TileList



// WEBPACK FOOTER //
// ./src/components/TileList/index.js